
import { reactive} from "vue";
import DynamicForm from "@/components/Shared/Dynamicform/DynamicForm.vue";

export default {
  name: "WildBookObserveSpecLocation",
  inheritAttrs: false,
  components: {
    DynamicForm
  },
  setup() {
    const request = reactive({
      apiLoadMethod: "",
      apiSaveMethod: "",
      form: "WildbuchEintragBeobachtungSpez",
      page: "WildbuchEintragOrtBeobachtungSpezial",
      remoteId: "",
      
      

    });
    return {
      request
    };
  }
};
